// NavMenu

export default {
  news: {
    en: "News",
    fr: "Actualité"
  },
  projects: {
    en: "Projects",
    fr: "Projets"
  },
  backoffice: {
    en: "Platform",
    fr: "Plateforme"
  },
  group: {
    en: "Group",
    fr: "Groupe"
  },
  network: {
    en: "Network",
    fr: "Réseau"
  },
  settings: {
    en: "My account",
    fr: "Mon compte"
  }
};
